import React, { useState } from "react";
import {
  Box,
  Container,
  Link,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
} from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu"; // Note: You may need to run `npm install @mui/icons-material`

const navLinks = ["Expertise", "Works", "Experience", "Contact"];

const Navigation = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setMobileOpen(open);
  };

  return (
    <Box
      component="nav"
      sx={{
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 50,
        borderBottom: "1px solid",
        borderColor: "custom.white5",
        bgcolor: "rgba(10, 10, 12, 0.8)",
        backdropFilter: "blur(12px)",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          px: 3,
          height: 80,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 0.5,
            }}
          >
            <Typography
              sx={{
                color: "custom.midnight",
                fontWeight: 700,
                fontFamily: "mono",
              }}
            >
              A
            </Typography>
          </Box>
          <Typography
            sx={{
              fontFamily: "mono",
              fontSize: "0.875rem",
              letterSpacing: "-0.05em",
              textTransform: "uppercase",
              fontWeight: 500,
            }}
          >
            Ahmad Hanafi
          </Typography>
        </Box>

        {/* Desktop Links */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            gap: 5,
          }}
        >
          {navLinks.map((link) => (
            <Link
              key={link}
              href={`#${link.toLowerCase()}`}
              sx={{
                fontSize: "0.75rem",
                fontFamily: "mono",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "text.primary",
                textDecoration: "none",
                transition: "color 0.3s",
                "&:hover": { color: "primary.main" },
              }}
            >
              {link}
            </Link>
          ))}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography
            sx={{
              display: { xs: "none", sm: "block" },
              fontSize: "10px",
              fontFamily: "mono",
              color: "text.secondary",
              textTransform: "uppercase",
              border: "1px solid",
              borderColor: "custom.white10",
              px: 1.5,
              py: 0.5,
              borderRadius: "999px",
            }}
          >
            Available for hire
          </Typography>

          {/* Mobile Menu Toggle */}
          <IconButton
            onClick={toggleDrawer(true)}
            sx={{ display: { md: "none" }, color: "white" }}
          >
            <span className="material-symbols-outlined">menu</span>
          </IconButton>
        </Box>
      </Container>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: { width: "250px", bgcolor: "custom.midnight", p: 3 },
        }}
      >
        <List sx={{ pt: 4 }}>
          {navLinks.map((link) => (
            <ListItem key={link} disablePadding sx={{ mb: 4 }}>
              <Link
                href={`#${link.toLowerCase()}`}
                onClick={toggleDrawer(false)}
                sx={{
                  fontFamily: "mono",
                  fontSize: "1.25rem",
                  textDecoration: "none",
                  color: "white",
                  textTransform: "uppercase",
                }}
              >
                {link}
              </Link>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Box>
  );
};

export default Navigation;
